import { useEffect } from "react";
import { AppRoot } from "@/pages/AppRoot";

export function App() {
  useEffect(() => {
    const autoResize = (e: Event) => {
      const el = e.target;
      if (el instanceof HTMLTextAreaElement) {
        el.style.height = "auto";
        el.style.height = el.scrollHeight + "px";
      }
    };
    document.addEventListener("input", autoResize);
    return () => document.removeEventListener("input", autoResize);
  }, []);

  return <AppRoot />;
}
